export default __webpack_public_path__ + "static/media/meat-white.6ac56034.svg";